<template>
  <div v-loading="loading">
    <search-base
      ref="SearchBase"
      :data="formData"
      @search="handleSearch"
      :hideFileds="hideFileds"
    >
      <template v-slot:footer>
        <el-col :span="8">
          <el-form-item label="人员行业分类" prop="industry">
            <el-select
              v-model="query.industry"
              placeholder="请选择人员行业分类"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in formData.industrys"
                :key="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="专业技术职称" prop="appellationId">
            <el-cascader
              :options="formData.appellationTree"
              @change="handleAppellation"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="行政级别" prop="executLevel">
            <el-select
              v-model="query.executLevel"
              placeholder="请选择行政级别"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in formData.executiveLevels"
                :key="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tip><slot name="tip"></slot></template>
    </search-base>
  </div>
</template>

<script>
import SearchBase from './components/Base.vue';
import { getBoards } from '@/api/search/position/mavin.js';

export default {
  data() {
    return {
      loading: false,
      query: {},
      formData: {}
    };
  },
  components: {
    SearchBase
  },
  props: {
    hideFileds: {
      type: Array
    },
    speIds: {
      type: Array
    }
  },
  methods: {
    handleAppellation(value) {
      this.query.appellationId =
        value.length >= 1 ? parseInt(value[value.length - 1]) : null;
    },
    handleSearch(querys) {
      Object.assign(querys, this.query);
      querys.speIds = this.formData.speIds;

      this.$emit('search', querys);
    },
    getData() {
      this.loading = true;
      getBoards(this.query)
        .then(res => {
          this.formData = res;
          this.formData.speIds = this.speIds;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style></style>
